module.exports = __webpack_public_path__ + "static/media/information-circle-outline.04b73f0d.svg";